module.exports = __webpack_public_path__ + "img/logo.ff3ade2d.jpg";